import { useQuery } from 'hooks/useCustomQuery';
import { getAvailableRegions } from 'API/TRSRegistrar/getAvailableRegions';

/**
 * Custom hook for fetching and caching available regions for TRS registrars
 * Uses the new TRSRegistrars/AvailableRegions endpoint
 */
const useAvailableRegions = () => {
    return useQuery({
        queryKey: ['availableRegions'],
        queryFn: getAvailableRegions,
        staleTime: 10 * 60 * 1000, // 10 minutes - regions change infrequently
        cacheTime: 15 * 60 * 1000, // 15 minutes
        refetchOnWindowFocus: false,
        retry: 2,
    });
};

export default useAvailableRegions;
